// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"dc91af6d","470":"7caf9f95","623":"37c59424"}[chunkId] + ".chunk.css";
};